import React from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

// Import all setting pages
import SchoolsSetting from "./SettingPages/SchoolSetting/SchoolsSetting";
import RequiredDocument from "./SettingPages/SchoolSetting/RequiredDocument";
import NotFound from "./SettingPages/NotFound/NotFound";


const SettingPageContainer = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const getSettingPageComponent = (route) => {
    switch (route) {
      // School Setting routes
      case "/schoolSettings/studentSetting/requiredDocument":
        return <RequiredDocument />;
      case "/schoolSettings/schoolSetting/school":
        return <SchoolsSetting />;

      // Add more cases for other settings pages as needed
      default:
        return <NotFound />;
    }
  };

  if (!currentPath || currentPath === "/schoolSettings") {
    return (
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          color: "text.secondary",
        }}
      >
        Please select a setting category from the sidebar to get started.
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        p: 0,
      }}
    >
      {getSettingPageComponent(currentPath)}
    </Box>
  );
};

export default SettingPageContainer;
